module.exports = __webpack_public_path__ + "static/media/semantic.15d1c10e.png";